import React from 'react';
import { useAuth } from '../hooks/useAuth';
import type { Comment } from '../hooks/useComments';
import CommentList from './CommentList';
import CommentForm from './CommentForm';

type ActivityFeedProps = {
  comments: Comment[];
  onAddComment: (content: string, parentId: string | null) => Promise<void>;
  onUpdateComment: (commentId: string, content: string) => Promise<void>;
  onDeleteComment: (commentId: string) => Promise<void>;
  canDeleteComment: (commentUserId: string) => boolean;
  ideaAuthorId: string;
};

export default function ActivityFeed({
  comments,
  onAddComment,
  onUpdateComment,
  onDeleteComment,
  canDeleteComment,
  ideaAuthorId
}: ActivityFeedProps) {
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      {/* Discussions section */}
      <section className="space-y-6">
        <h2 className="text-2xl font-bold" style={{ color: 'var(--color-font)' }}>Discussions</h2>
        
        {user && (
          <CommentForm onSubmit={(content) => onAddComment(content, null)} />
        )}

        <CommentList
          comments={comments}
          onUpdateComment={onUpdateComment}
          onDeleteComment={onDeleteComment}
          onAddComment={onAddComment}
          canDeleteComment={canDeleteComment}
          ideaAuthorId={ideaAuthorId}
        />
      </section>
    </div>
  );
}